/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalculationParameterKey,
  CalculationParameterResponse,
  DropdownCategory,
  DropdownOptionResponse,
  ProblemDetails,
  SaveCalculationParameterEntriesRequest,
  UpdateDropdownOptionsRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CalculationParameterKeyFromJSON,
    CalculationParameterKeyToJSON,
    CalculationParameterResponseFromJSON,
    CalculationParameterResponseToJSON,
    DropdownCategoryFromJSON,
    DropdownCategoryToJSON,
    DropdownOptionResponseFromJSON,
    DropdownOptionResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SaveCalculationParameterEntriesRequestFromJSON,
    SaveCalculationParameterEntriesRequestToJSON,
    UpdateDropdownOptionsRequestFromJSON,
    UpdateDropdownOptionsRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface DeleteCalculationParameterEntryRequest {
    key: CalculationParameterKey;
    entryId: string;
}

export interface GetDropdownOptionsByCategoryRequest {
    category: DropdownCategory;
}

export interface SaveCalculationParameterEntriesOperationRequest {
    key: CalculationParameterKey;
    saveCalculationParameterEntriesRequest: SaveCalculationParameterEntriesRequest;
}

export interface UpdateDropdownOptionsOperationRequest {
    category: DropdownCategory;
    updateDropdownOptionsRequest: UpdateDropdownOptionsRequest;
}

/**
 * SettingsApi - interface
 * 
 * @export
 * @interface SettingsApiInterface
 */
export interface SettingsApiInterface {
    /**
     * 
     * @param {CalculationParameterKey} key 
     * @param {string} entryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    deleteCalculationParameterEntryRaw(requestParameters: DeleteCalculationParameterEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteCalculationParameterEntry(requestParameters: DeleteCalculationParameterEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    getAllCalculationParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalculationParameterResponse>>>;

    /**
     */
    getAllCalculationParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalculationParameterResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    getAllDropdownOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>>;

    /**
     */
    getAllDropdownOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>>;

    /**
     * 
     * @param {DropdownCategory} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    getDropdownOptionsByCategoryRaw(requestParameters: GetDropdownOptionsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>>;

    /**
     */
    getDropdownOptionsByCategory(requestParameters: GetDropdownOptionsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>>;

    /**
     * 
     * @param {CalculationParameterKey} key 
     * @param {SaveCalculationParameterEntriesRequest} saveCalculationParameterEntriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    saveCalculationParameterEntriesRaw(requestParameters: SaveCalculationParameterEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationParameterResponse>>;

    /**
     */
    saveCalculationParameterEntries(requestParameters: SaveCalculationParameterEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationParameterResponse>;

    /**
     * 
     * @param {DropdownCategory} category 
     * @param {UpdateDropdownOptionsRequest} updateDropdownOptionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApiInterface
     */
    updateDropdownOptionsRaw(requestParameters: UpdateDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>>;

    /**
     */
    updateDropdownOptions(requestParameters: UpdateDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>>;

}

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI implements SettingsApiInterface {

    /**
     */
    async deleteCalculationParameterEntryRaw(requestParameters: DeleteCalculationParameterEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteCalculationParameterEntry().'
            );
        }

        if (requestParameters['entryId'] == null) {
            throw new runtime.RequiredError(
                'entryId',
                'Required parameter "entryId" was null or undefined when calling deleteCalculationParameterEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/calculation-parameters/{key}/entries/{entryId}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));
        urlPath = urlPath.replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters['entryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCalculationParameterEntry(requestParameters: DeleteCalculationParameterEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCalculationParameterEntryRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllCalculationParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalculationParameterResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/calculation-parameters`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CalculationParameterResponseFromJSON));
    }

    /**
     */
    async getAllCalculationParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalculationParameterResponse>> {
        const response = await this.getAllCalculationParametersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDropdownOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/dropdown-options`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DropdownOptionResponseFromJSON));
    }

    /**
     */
    async getAllDropdownOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>> {
        const response = await this.getAllDropdownOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getDropdownOptionsByCategoryRaw(requestParameters: GetDropdownOptionsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getDropdownOptionsByCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/dropdown-options/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DropdownOptionResponseFromJSON));
    }

    /**
     */
    async getDropdownOptionsByCategory(requestParameters: GetDropdownOptionsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>> {
        const response = await this.getDropdownOptionsByCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveCalculationParameterEntriesRaw(requestParameters: SaveCalculationParameterEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationParameterResponse>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling saveCalculationParameterEntries().'
            );
        }

        if (requestParameters['saveCalculationParameterEntriesRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCalculationParameterEntriesRequest',
                'Required parameter "saveCalculationParameterEntriesRequest" was null or undefined when calling saveCalculationParameterEntries().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/calculation-parameters/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCalculationParameterEntriesRequestToJSON(requestParameters['saveCalculationParameterEntriesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalculationParameterResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveCalculationParameterEntries(requestParameters: SaveCalculationParameterEntriesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationParameterResponse> {
        const response = await this.saveCalculationParameterEntriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDropdownOptionsRaw(requestParameters: UpdateDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DropdownOptionResponse>>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling updateDropdownOptions().'
            );
        }

        if (requestParameters['updateDropdownOptionsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDropdownOptionsRequest',
                'Required parameter "updateDropdownOptionsRequest" was null or undefined when calling updateDropdownOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/dropdown-options/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDropdownOptionsRequestToJSON(requestParameters['updateDropdownOptionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DropdownOptionResponseFromJSON));
    }

    /**
     */
    async updateDropdownOptions(requestParameters: UpdateDropdownOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DropdownOptionResponse>> {
        const response = await this.updateDropdownOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
